import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import MaterialTable from "material-table";
import { IconButton } from "@material-ui/core";
import Icon from "@jll/icon";
import Tooltip from "@material-ui/core/Tooltip";
import styles from "./styles";

import {
  tableStyle,
  tableOptions,
  tableIcons,
} from "../../../../Component/Table/tableCommonStyles";

import { LongText } from "../../../../Component";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(styles);

const LinkTable = ({
  data,
  onRowViewClick,
  canAddLinks,
  canRemoveLinks,
  removeLink,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const initiateView = (doc) => {
    if (onRowViewClick && typeof onRowViewClick === "function") {
      onRowViewClick(doc);
    }
  };

  return (
    <div className={classes.tableWrapper}>
      <MaterialTable
        style={tableStyle}
        icons={tableIcons}
        options={tableOptions}
        isLoading={false}
        data={data}
        localization={{
          header: {
            actions: t("labels.common.table.actions"),
          },
          body: {
            emptyDataSourceMessage: t("labels.common.table.noRecordsFound"),
          },
        }}
        columns={[
          {
            title: t("labels.record.links.table.headers.url"),
            field: "url",
            render: (rowData) => {
              let link = (rowData.url || "").toLowerCase();
              link =
                link.startsWith("http://") || link.startsWith("https://")
                  ? link
                  : `http://${link}`;
              return (
                <a href={link} target="_blank" rel="noopener noreferrer">
                  <LongText text={rowData.url} width="300px" />
                </a>
              );
            },
          },
          {
            title: t("labels.record.links.table.headers.description"),
            field: "description",
            render: (rowData) => {
              return <LongText text={rowData.description} />;
            },
          },
          {
            title: t("labels.record.links.table.headers.createdBy"),
            field: "created_by_user_name",
          },
        ]}
        actions={[
          canAddLinks && {
            icon: "edit",
            position: "row",
            onClick: (event, rowData) => initiateView(rowData),
          },
          canRemoveLinks && {
            icon: "remove",
            position: "row",
            onClick: (event, rowData) => removeLink(rowData),
          },
        ]}
        components={{
          Action: (props) => {
            switch (props.action.icon) {
              case "edit":
                return (
                  <Tooltip title={t("labels.common.edit")} placement="bottom">
                    <IconButton
                      onClick={(event) =>
                        props.action.onClick(event, props.data)
                      }
                      style={{ fontSize: 16 }}
                    >
                      <Icon className="far fa-edit" />
                    </IconButton>
                  </Tooltip>
                );
              case "remove":
                return (
                  <Tooltip title={t("labels.common.remove")} placement="bottom">
                    <IconButton
                      onClick={(event) =>
                        props.action.onClick(event, props.data)
                      }
                      style={{ fontSize: 16 }}
                    >
                      <Icon className="far fa-trash-alt" />
                    </IconButton>
                  </Tooltip>
                );
              default:
                return null;
            }
          },
        }}
      />
    </div>
  );
};

export default LinkTable;
